import { Injectable } from '@angular/core';
import { ComparisonTableView, ReadingTableView } from 'src/app/services/models/reading-table-view.model';
import { IExportReportDataSource } from 'src/app/modules/shared/components/export-report/export-report.component';
import { DEVICE_KEYS } from '../static-datas/interval-options.static';
import { DecimalPipe } from '@angular/common';

@Injectable()
export class ComparisonTableService {

  // ! Service Needs rework and clean up

  constructor( private decimalPipe: DecimalPipe,) { }

  GenerateReadingTableModel(data: any[], name: string, tab: string, icons?: string[], headers?: string[], props?: string[],lastTelemetryReadings?: string, firstReadingTimestamp?: string,selectedMeterName?: string) : Partial<ReadingTableView> {
    let tableModel = this.GetReadingTableConfig(name, tab, headers, props, lastTelemetryReadings, firstReadingTimestamp,selectedMeterName);
    if(icons && icons.length > 0) {
      tableModel.icons = icons
    }
    if(data && data.length > 0) {
      tableModel.data = [[]];
      for (let i = 0; i < data.length; i++) {
        const obj = data[i];
        tableModel.data[i] = [];
      
        if (obj) {
          tableModel.properties.forEach(prop => {
            let value = obj[prop];
      
            if (value === null || value === undefined || value === '') {
              tableModel.data[i].push('No data available');
            } else if (typeof value === 'string' && value.trim().toLowerCase() === 'na') {
              tableModel.data[i].push('N/A');
            } else if (typeof value === 'number' && Number.isFinite(value)) {
              tableModel.data[i].push(this.decimalPipe.transform(value,'1.0-2'));
            } else {
              tableModel.data[i].push(value);
            }
          });
        }
      }
    }
    return tableModel;
  }

  GenerateReadingTableModelFromEntity(data: any[], name: string, tab: string, icons?: string[]) : Partial<ReadingTableView> {
    let tableModel = this.GetReadingTableConfig(name, tab);
    if(icons && icons.length > 0) {
      tableModel.icons = icons
    }
    if(data && data.length > 0 && tableModel.data.length > 0) {
      for (var i = 0; i < tableModel.data.length; i++) {
        let row = tableModel.data[i];
        let prop = tableModel.properties[i];
        if (row && row.length > 0) {
          for (var j = 0; j < data.length; j++) {
            let obj = data[j];
            if (Number.isFinite(obj[prop])) {
              tableModel.data[i].push(obj[prop].toFixed(3));
            } else {
              tableModel.data[i].push(obj[prop]);
            }
          }
        }
      }
    }
    return tableModel;
  }

  GetSummaryComparison(selectedEntities: any[], mulltiResponses: any[], property: string, tableConfig: Partial<ReadingTableView>, tableName: string, tabName: string): Partial<ReadingTableView> {
    //this.spinner.show(this.comparisonTableLoader);
    if (!tableConfig) {
      tableConfig = this.GenerateReadingTableModel(null, tableName, tabName);
      tableConfig.headers = [tableName];
      tableConfig.properties = [tableName];
      for (var i = 0; i < selectedEntities.length; i++)
      {
        if (selectedEntities[i]) {
          tableConfig.headers.push(selectedEntities[i].name);
          tableConfig.properties.push(selectedEntities[i].name);
        }
      }
    }
    if (tableConfig && mulltiResponses && mulltiResponses.length > 0) {
      if (tableConfig.data && tableConfig.data.length > 0) {
        for (var i = 0; i < tableConfig.data.length; i++)
        {
          while (tableConfig.data[i].length != mulltiResponses.length + 1) {
            if (tableConfig.data[i].length > mulltiResponses.length + 1) {
              tableConfig.data[i].pop();
            } else if (tableConfig.data[i].length < mulltiResponses.length + 1) {
              tableConfig.data[i].push('-');
            }
          }
        }
      }
      for (var i = 0; i < mulltiResponses.length; i++)
      {
        if (mulltiResponses[i] && mulltiResponses[i].length > 0) {
          for (var j = 0; j < tableConfig.data.length; j++)
          {
            tableConfig.data[j][i+1] = mulltiResponses[i][j][property];
          }
        }
        else {
          tableConfig.headers[i+1] = selectedEntities[i].name;
          for (var j = 0; j < tableConfig.data.length; j++)
          {
            tableConfig.data[j][i+1] = 'No data available';
          }
        }
      }
    }
    return tableConfig;
  }

  GetMultiKeyComparison(selectedEntities: any[], mulltiResponses: any[], key: string, tableConfigList: Partial<ReadingTableView>[], tableNames: string[], tabName: string): Partial<ReadingTableView>[] {
    if (!tableConfigList || tableConfigList.length <= 0) {
      tableConfigList = [] as Partial<ReadingTableView>[];
      for (var i = 0; i < tableNames.length; i++)
      {
        let tableConfig = this.GenerateReadingTableModel(null, tableNames[i], tabName);
        tableConfig.headers = [tableNames[i]];
        tableConfig.properties = [tableNames[i]];
        for (var j = 0; j < selectedEntities.length; j++)
        {
          if (selectedEntities[j]) {
            tableConfig.headers.push(selectedEntities[j].name);
            tableConfig.properties.push(selectedEntities[j].name);
          }
        }
        tableConfigList.push(tableConfig);
      }
    }

    if (mulltiResponses && mulltiResponses.length > 0) {
      if (tableConfigList && tableConfigList.length > 0) {
        for (var i = 0; i < tableConfigList.length; i++)
        {
          if (tableConfigList[i].data && tableConfigList[i].data.length > 0) {
            for (var j = 0; j < tableConfigList[i].data.length; j++)
            {
              while (tableConfigList[i].data[j].length != mulltiResponses.length + 1) {
                if (tableConfigList[i].data[j].length > mulltiResponses.length + 1) {
                  tableConfigList[i].data[j].pop();
                } else if (tableConfigList[i].data[j].length < mulltiResponses.length + 1) {
                  tableConfigList[i].data[j].push('-');
                }
              }
            }
          }
        }
      }
      for (var r = 0; r < mulltiResponses.length; r++)
      {
        if (mulltiResponses[r] && mulltiResponses[r].length > 0) {
          if (tableConfigList && tableConfigList.length > 0) {
            for (var i = 0; i < tableConfigList.length; i++)
            {
              for (var j = 0; j < tableConfigList[i].data.length; j++)
              {
                var obj = mulltiResponses[r].find(x=> x.key == tableConfigList[i].data[j][0]);
                if (obj) {
                  tableConfigList[i].data[j][r+1] = obj.val;
                }
                else {
                  tableConfigList[i].data[j][r+1] = 'No data available';
                }
              }
            }
          }
        } else {
          for (var i = 0; i < tableConfigList.length; i++)
          {
            for (var j = 0; j < tableConfigList[i].data.length; j++)
            {
              tableConfigList[i].data[j][r+1] = 'No data available';
            }
          }
        }
      }
    }
    //this.comparisonTableConfigs = [];
    //this.comparisonTableConfigs.concat(tableConfigList);
    return tableConfigList;
  }

  GenerateReadingDataReport(tableModel: Partial<ReadingTableView>, data: any[], name: string = null): IExportReportDataSource {
    if(!name){
      name = tableModel.id;
    }
    if(!data || data.length <= 0){
      data = [];
      for (var i = 0; i < tableModel.data.length; i++) {
        var row = {};
        for (var j = 0; j < tableModel.properties.length; j++) {
          row[tableModel.properties[j]] = tableModel.data[i][j];
        }
        data.push(row);
      }
    }
    let dataSource: IExportReportDataSource = {
      name: name,
      rows: data,
      columns: []
    };
    for (var i = 0; i < tableModel.headers.length; i++) {
      dataSource.columns.push({ header: tableModel.headers[i], field: tableModel.properties[i] });
    }
    // console.log(dataSource);
    return dataSource;
  }

  GenerateComparisonDataReport(comparisonData: Partial<ComparisonTableView[]>, headers: string[], filterKeys: any): IExportReportDataSource[]  {
    let reportDataSources = [] as IExportReportDataSource[];

    let _categorys = comparisonData.filter(x => x.isCategory === true);
    _categorys.forEach(data => {
      let dataSource: IExportReportDataSource = {
        name: '',
        rows: [],
        columns: []
      };
      let ignoreComulns = ["key", "unit", "icon", "alert", "isCategory"];
      let _comulns = Object.entries(data).filter(([comuln, _]) => !ignoreComulns.includes(comuln)).map(([key, value]) => ({ key, value }));
      let _rows = comparisonData.filter(x => x.isCategory === false);
      dataSource.name = data.name;
      dataSource.columns = _comulns.map(x => ({ header: String(x.value), field: x.key }));
      if (filterKeys) {
        _rows = comparisonData.filter(x => filterKeys[data.key]
          && (filterKeys[data.key] && filterKeys[data.key].length > 0)
          && filterKeys[data.key].keys.includes(x.key) && x.isCategory === false);
      }
      if (_rows && _rows.length > 0) {
        dataSource.rows = _rows;
      }
      reportDataSources.push(dataSource);
    });

    return reportDataSources;
  }

  GetReadingTableConfig(name: string, tab: string, headers?: string[], props?: string[], lastTelemetryReadings?:string, firstReadingTimestamp?:string ,selectedMeter?:string ): Partial<ReadingTableView> {
    let tableConfig: Partial<ReadingTableView> = {
      id: name.toLocaleLowerCase(),
      icons: [""],
      alerts: [4],
      headers: [name, 'Current value', 'Maximum value', 'Minimum value', 'Status'],
      properties: ['key', 'val', 'max_val', 'min_val', 'status'],
      data: [[]], //as ComparisonTableModel
      useBoldHeader: false
    };

    if (tab == "technical-readings-pills" || tab == "units-energy-usage-comparison") {
      tableConfig.headers = [name, 'Current value', 'Maximum value', 'Minimum value', 'Status'];
      if (name.toLocaleLowerCase() == "entity") {
        tableConfig.headers = ['Summary', 'Consuelo Living room', 'Joni Corridor', 'Bettye Bathroom'];
        tableConfig.properties = ['units_name', 'total_consumption_kwh', 'total_consumption_sar', 'running_time', 'connected_devices', 'connected_appliances', 'ratio_of_total_load'];
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.useBoldHeader = true;
        tableConfig.data = [
          ['Units Name'],
          ['Total Consumption KWh'],
          ['Total Consumption SAR'],
          ['Running Time'],
          ['Connected Devices'],
          ['Connected Appliances'],
          ['Ratio of total load'],
          ['Total KWh'],
        ];
      } else if (name.toLocaleLowerCase() == "summary") {
        if (tab == "technical-readings-pills") {
          tableConfig.headers = ['Summary', 'Current value', 'Maximum value', 'Minimum value', 'Rank'];
          tableConfig.properties = ['Summary', 'Current Value', 'Maximum Value', 'Minimum Value', 'Rank'];
        }
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.alerts = [4];
        tableConfig.properties = ['Summary', 'Current Value', 'Maximum Value', 'Minimum Value', 'Status'];
        tableConfig.units = ['', '', '', '', '', '%', 'KWh'];
        tableConfig.data = [
          ['Total Consumption KWh', 'No data available', '-', '-', 'NA'],
          ['Total Consumption SAR', 'No data available', '-', '-', 'NA'],
          ['Running Time', 'No data available', '-', '-', 'NA'],
          // ['Connected Devices', 'No data available', '-', 'NA'],
          // ['Connected Appliances', 'No data available', '-', 'NA'],
          ['Ratio of total load', 'No data available', '-','-','NA'],
          ['Total KWh', 'No data available', '-', '-'],
        ];
        tableConfig.explanation = `The following data represents data from ${firstReadingTimestamp} until: ${lastTelemetryReadings} , for the ${selectedMeter} Meter`;
        tableConfig.anotherExplanation = `The following table represents the data from: ${lastTelemetryReadings}`;
      }else if (name.toLocaleLowerCase() === "kilowatt hour"){
        tableConfig.icons = ["fa-solid fa-dial-high"];
        tableConfig.units = ['KWh']
        tableConfig.data = tableConfig.data = [
          ['kWh', 'No data available', '-', '-'],
        ];;
      } else if (name.toLocaleLowerCase() === "co₂ emission" ||name.toLocaleLowerCase() === "co2 emission"){
        tableConfig.icons = ["fa-solid fa-leaf"];
        tableConfig.units = ['kg CO₂e']
        tableConfig.data = tableConfig.data = [
          ['CO2', 'No data available', '-', '-'],
        ];;
      }  
      else if (name.toLocaleLowerCase() == "power factor") {
        tableConfig.icons = ["fa-solid fa-empty-set"];
        tableConfig.data = tableConfig.data = [
          ['PFa', 'No data available', '-', '-'],
          ['PF1', 'No data available', '-', '-'],
          ['PF2', 'No data available', '-', '-'],
          ['PF3', 'No data available', '-', '-'],
        ];;
      } else if (name.toLocaleLowerCase() == "voltage to line") {
        tableConfig.icons = ["fa-solid fa-bolt"];
        tableConfig.units = ['volts','volts','volts','volts'];
        tableConfig.data = [
          ['Va', 'No data available', '-', '-'],
          ['V1', 'No data available', '-', '-'],
          ['V2', 'No data available', '-', '-'],
          ['V3', 'No data availables', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "voltage to neutral") {
        tableConfig.icons = ["fa-duotone fa-bolt-lightning"];
        tableConfig.units = ['volts', 'volts', 'volts', 'volts'];
        tableConfig.data = [
          ['Vna', 'No data available', '-', '-'],
          ['Vn1', 'No data available', '-', '-'],
          ['Vn2', 'No data available', '-', '-'],
          ['Vn3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "frequency") {
        tableConfig.icons = ["fa fa-wave-square"];
        tableConfig.units = ['Hz'];
        tableConfig.data = [
          ['Hz', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "current" || name.toLocaleLowerCase() == "current (amperage)") {
        tableConfig.headers[0] = "Current (Amperage)";
        tableConfig.icons = ["fa-solid fa-a"];
        tableConfig.units = ['A', 'A', 'A', 'A'];
        tableConfig.data = [
          ['Ampa', 'No data available', '-', '-'],
          ['Amp1', 'No data available', '-', '-'],
          ['Amp2', 'No data available', '-', '-'],
          ['Amp3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "power") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW','kW','kW','kW'];
        tableConfig.data = [
          ['TkW', 'No data available', '-', '-'],
          ['kW1', 'No data available', '-', '-'],
          ['kW2', 'No data available', '-', '-'],
          ['kW3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "active power consumed") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW','kW','kW','kW'];
        tableConfig.data = [
          ['TkW', 'No data available', '-', '-'],
          ['kW1', 'No data available', '-', '-'],
          ['kW2', 'No data available', '-', '-'],
          ['kW3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "reactive power consumed") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW','kW','kW','kW'];
        tableConfig.data = [
          ['TkVAr', 'No data available', '-', '-'],
          ['kVAr1', 'No data available', '-', '-'],
          ['kVAr2', 'No data available', '-', '-'],
          ['kVAr3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "apparent power") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW','kW','kW','kW'];
        tableConfig.data = [
          //['kVAh', '13.65', '392.39', '588.79'],
          ['kVAh', 'No data available', '-', '-'],
          ['kVA1', 'No data available', '-', '-'],
          ['kVA2', 'No data available', '-', '-'],
          ['kVA3', 'No data available', '-', '-'],
        ];
      }
    } else if (tab == "readings-comparison-pills") {
      tableConfig.headers = [name, ...headers];
      tableConfig.properties = ['name', ...props];
      if (name.toLocaleLowerCase() == "summary") {
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.units = ['KWh', 'SAR', '', '', '', '%'];
        tableConfig.data = [
          ['Total Consumption KWh', 'No data available', '-', '-'], //['Total Consumption KWh', '14,745.00 KWh', '145.00 KWh', '1500.00 KWh'],
          ['Total Consumption SAR', 'No data available', '-', '-'], //['Total Consumption SAR', '2654.1 SAR', '26.1 SAR', '270 SAR'],
          ['Running Time', 'No data available', '-', '-'], //['Running Time', '64 hours', '12 hours', '108 hours'],
          ['Connected Devices', 'No Data available', '-', '-'],
          ['Connected Appliances', 'No Data available', '-', '-'],
          ['Ratio of total load', 'No Data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() === "kilowatt hour"){
          tableConfig.icons = ["fa-solid fa-dial-high"];
          tableConfig.units = ['KWh']
          tableConfig.data = tableConfig.data = [
            ['kWh', 'No data available', '-', '-'],
          ];;
      } 
      else if (
        name.toLocaleLowerCase() === "co₂ emission" ||
        name.toLocaleLowerCase() === "co2 emission"
      ) {
        tableConfig.icons = ["fa-solid fa-leaf"];
        tableConfig.units = ['kg CO₂e'];
        tableConfig.data = [
          ['CO2', 'No data available', '-', '-'],
        ];
      }
      else if (name.toLocaleLowerCase() == "power factor") {
        tableConfig.icons = ["fa-solid fa-empty-set"];
        tableConfig.data = tableConfig.data = [
          //['PF1', '0.1', '0.8', '0.6'],
          ['PFa', 'No data available', '-', '-'],
          ['PF1', 'No data available', '-', '-'],
          ['PF2', 'No data available', '-', '-'],
          ['PF3', 'No data available', '-', '-'],
        ];;
      } else if (name.toLocaleLowerCase() == "line lo line voltage") {
        tableConfig.icons = ["fa-solid fa-bolt"];
        tableConfig.units = ['volts', 'volts', 'volts', 'volts'];
        tableConfig.data = [
          //['V1', '393.12 volts', '221 volts', '127 volts'],
          ['Va', 'No data available', '-', '-'],
          ['V1', 'No data available', '-', '-'],
          ['V2', 'No data available', '-', '-'],
          ['V3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "line to neutral voltage") {
        tableConfig.icons = ["fa-duotone fa-bolt-lightning"];
        tableConfig.units = ['volts', 'volts', 'volts', 'volts'];
        tableConfig.data = [
          //['Vn1', '227.98 volts', '224.55 volts', '114 volts'],
          ['Vna', 'No data available', '-', '-'],
          ['Vn1', 'No data available', '-', '-'],
          ['Vn2', 'No data available', '-', '-'],
          ['Vn3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "frequency") {
        tableConfig.icons = ["fa fa-wave-square"];
        tableConfig.units = ['Hz'];
        tableConfig.data = [
          //['Frequency', '~ 59 Hz', '~ 60 Hz', '~ 58 Hz'],
          ['Frequency', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "current" || name.toLocaleLowerCase() == "current (amperage)") {
        tableConfig.headers[0] = "Current (Amperage)";
        tableConfig.icons = ["fa-solid fa-a"];
        tableConfig.units = ['A', 'A', 'A', 'A'];
        tableConfig.data = [
          //['Amp1', '60.61', '14.66', '28.32'],
          ['Ampa', 'No data available', '-', '-'],
          ['Amp1', 'No data available', '-', '-'],
          ['Amp2', 'No data available', '-', '-'],
          ['Amp3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "power") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW'];
        tableConfig.data = [
          //['kW1', '13.65', '392.39', '588.79'],
          ['Total KW ', 'No data available', '-', '-'],
          ['kW1', 'No data available', '-', '-'],
          ['kW2', 'No data available', '-', '-'],
          ['kW3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "active power consumed") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW', 'kW', 'kW', 'kW'];
        tableConfig.data = [
          ['TkW', 'No data available', '-', '-'],
          ['kW1', 'No data available', '-', '-'],
          ['kW2', 'No data available', '-', '-'],
          ['kW3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "reactive power consumed") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW', 'kW' , 'kW', 'kW'];
        tableConfig.data = [
          ['TkVAr', 'No data available', '-', '-'],
          ['kVAr1', 'No data available', '-', '-'],
          ['kVAr2', 'No data available', '-', '-'],
          ['kVAr3', 'No data available', '-', '-'],
        ];
      } else if (name.toLocaleLowerCase() == "apparent power") {
        tableConfig.icons = ["fa-solid fa-outlet"];
        tableConfig.units = ['kW'];
        tableConfig.data = [
          //['kVAh', '13.65', '392.39', '588.79'],
          ['kVAh', 'No data available', '-', '-'],
          ['kVA1', 'No data available', '-', '-'],
          ['kVA2', 'No data available', '-', '-'],
          ['kVA3', 'No data available', '-', '-'],
        ];
      }
    } else if (tab == "units-energy-usage-comparison") {
      tableConfig.headers = ['Summary', 'Consuelo Living room', 'Joni Corridor', 'Bettye Bathroom'];
      tableConfig.properties = ['units_name', 'total_consumption_kwh', 'total_consumption_sar', 'running_time', 'connected_devices', 'connected_appliances', 'ratio_of_total_load'];
      if (name.toLocaleLowerCase() == "entity") {
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.useBoldHeader = true;
        tableConfig.data = [
          ['Units Name'],
          ['Total Consumption KWh'],
          ['Total Consumption SAR'],
          ['Running Time'],
          ['Connected Devices'],
          ['Connected Appliances'],
          ['Ratio of total load'],
        ];
      } else if (name.toLocaleLowerCase() == "summary") {
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.alerts = [4];
        tableConfig.headers = ['Summary', 'Current value', 'Maximum value', 'Minimum value', 'Status'];
        tableConfig.properties = ['Summary', 'Current Value', 'Maximum Value', 'Minimum Value', 'Status'];
        tableConfig.units = ['KWh', 'SAR', '', '', '', '%'];
        tableConfig.data = [
          ['Total Consumption KWh', 'No data available', '-', '-', '-'],
          ['Total Consumption SAR', 'No data available', '-', '-', '-'],
          ['Running Time', 'No data available', '-', '-', '-'],
          ['Connected Devices', 'No data available', '-', '-'],
          ['Connected Appliances', 'No data available', '-', '-'],
          ['Ratio of total load', 'No data available', '-', '-'],
        ];
      }
    } else if (tab == "units-water-usage-comparison") {
      tableConfig.alerts = [0];
      tableConfig.headers = [name, 'Dominique Kitchen', 'Terrell Living room', 'Violet Room'];
      tableConfig.properties = ['connected_appliances', 'connected_devices', 'ratio_of_total_load', 'running_time', 'total_consumption_l', 'total_consumption_sar'];
      if (name.toLocaleLowerCase() == "summary") {
        tableConfig.icons = ["fa-duotone fa-chart-pie"];
        tableConfig.useBoldHeader = false;
        tableConfig.data = [
          ['Connected Appliances'],
          ['Connected Devices'],
          ['Ratio of total load'],
          ['Running Time'],
          ['Total Consumption L'],
          ['Total Consumption SAR'],
          // water row , API response name
          // ['Connected Units'], (connected_units)
          // ['Consumption '], (m)
          // ['Consumption Cost SAR'], (sar)
          // ['Consumption State'], (state)
          // ['Consumption ratio'] (consumption_ratio)
        ];
      }
    }

    return tableConfig;
  }

  GetReadingTableHtml(tableConfig: Partial<ReadingTableView>, tab: string): string {

    let readingTableHtml: string = '';

    if (tableConfig) {

      readingTableHtml += '<tbody id="' + tableConfig.id + '" data-filter="target">';
      readingTableHtml += '<tr class="bg-label-primary ">';

      for (var i = 0; i < tableConfig.headers.length; i++) {
        if (i == 0 || tableConfig.useBoldHeader) {
          readingTableHtml += '<th>';
          if (tableConfig.icons[i]) {
            readingTableHtml += '<i class="' + tableConfig.icons[i] + ' me-2"></i>'
          }
          readingTableHtml += tableConfig.headers[i] + '</th>';
        } else if (i > 0) {
          readingTableHtml += '<td>';
          if (tableConfig.icons[i]) {
            readingTableHtml += '<i class="' + tableConfig.icons[i] + ' me-2"></i>'
          }
          readingTableHtml += '<span>' + tableConfig.headers[i] + '</span></td>';
        }
        //console.log(readingTableConfig.headers[i]);
      }

      readingTableHtml += '</tr>';

      if (tableConfig.explanation) {
        readingTableHtml += `
          <tr>
            <td colspan="${tableConfig.headers.length}" style="text-align: left; font-style: italic; background: #f9f9f9; padding: 8px;">
              ${tableConfig.explanation}
            </td>
          </tr>
        `;
      }

      for (var j = 0; j < tableConfig.data.length; j++) {
        readingTableHtml += '<tr>';
        for (var k = 0; k < tableConfig.data[j].length; k++){
          //console.log(tableConfig.headers[i]);
          if (k == 0) {
            readingTableHtml += '<th>' + tableConfig.data[j][k] + '</th>';
          } 
          else if (k > 0 && (tableConfig.alerts.includes(0) || !tableConfig.alerts.includes(k))) {
            readingTableHtml += '<td>';
            if (tableConfig.data[j][k] && tableConfig.data[j][k] != "-") {
              readingTableHtml += tableConfig.data[j][k];
              if (tableConfig.data[j][0].includes('Amp')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                  readingTableHtml += ' <small>A</small>';
                }
              }
              else if (tableConfig.data[j][0]?.includes('KWh')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' KWh';
                }
              }
              else if (tableConfig.data[j][0]?.includes('CO2')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' kg CO₂e';
                }
              }
              else if (tableConfig.data[j][0]?.includes('kw')
              || tableConfig.data[j][0]?.toLocaleLowerCase().includes('tkw')
              || tableConfig.data[j][0]?.toLocaleLowerCase().includes('kva'))
              {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                  readingTableHtml += ' <small>kW</small>';
                }
              }
              else if (tableConfig.data[j][0]?.includes('SAR')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                  readingTableHtml += ' SAR';
                }
              }
              else if (tableConfig.data[j][0]?.toLocaleLowerCase().includes('time')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' ';
                }
              }
              else if (tableConfig.data[j][0]?.toLocaleLowerCase().includes('devices')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' ';
                }
              }
              else if (tableConfig.data[j][0]?.toLocaleLowerCase().includes('appliances')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' ';
                }
              }
              else if (tableConfig.data[j][0]?.toLocaleLowerCase().includes('ratio')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += '%';
                }
              }
              else if (tableConfig.id.includes('voltage')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' volts';
                }
              }
              else if (tableConfig.id.includes('frequency')) {
                if(tableConfig.data[j][k] != 'No data available' && tableConfig.data[j][k] != 'NA' && tableConfig.data[j][k] != 'Key does not exist') {
                   readingTableHtml += ' Hz';
                }
              }
            }
            else {
              readingTableHtml += '-';
            }
            readingTableHtml += '</td>';
          } else if (k > 0 && tableConfig.alerts.includes(k)) {
            if (tableConfig.data[j][k].toLocaleLowerCase() == 'high') {
              // readingTableHtml +=
              // `<td>
              //   <span class="badge bg-label-danger" data-bs-toggle="tooltip" data-bs-placement="top"
              //     title="The current reading is above or close to the maximum value">
              //     <i class="fa-solid me-2 fa-light-emergency-on"></i> ` + tableConfig.data[j][k] +
              //   `</span>
              // </td>`;

              readingTableHtml +=
              `<td>
                <div class="badge bg-label-danger tooltip1">
                  <i class="fa-solid me-2 fa-light-emergency-on"></i> ` + tableConfig.data[j][k] +
                `<span class="tooltiptext1">The current reading is above or close to the maximum value</span>
                </div>
              </td>`;

              // readingTableHtml +=
              // `<td>
              //   <span class="badge bg-label-danger" tech-read-tt-high [ngbTooltip]="'The current reading is above or close to the maximum value'" placement="top">
              //     <i class="fa-solid me-2 fa-light-emergency-on"></i> ` + tableConfig.data[j][k] +
              //   `</span>
              // </td>`;
            } else if (tableConfig.data[j][k].toLocaleLowerCase() == 'normal') {
              // readingTableHtml +=
              // `<td>
              //   <span class="badge  bg-label-info" data-bs-toggle="tooltip" data-bs-placement="top"
              //     title="The current reading is in normal range">
              //     <i class="fa-solid me-2 fa-triangle-exclamation"></i> ` + tableConfig.data[j][k] +
              //   `</span>
              // </td>`;

              readingTableHtml +=
              `<td>
                <div class="badge bg-label-info tooltip1">
                  <i class="fa-solid me-2 fa-triangle-exclamation"></i> ` + tableConfig.data[j][k] +
                `<span class="tooltiptext1">The current reading is in normal range</span>
                </div>
              </td>`;

            } else if (tableConfig.data[j][k].toLocaleLowerCase() == 'low') {
              // readingTableHtml +=
              // `<td>
              //   <span class="badge bg-label-secondary" data-bs-toggle="tooltip" data-bs-placement="top"
              //     title="The current reading is above or close to the minimum value">
              //     <i class="fa-solid me-2 fa-circle-exclamation"></i> ` + tableConfig.data[j][k] +
              //   `</span>
              // </td>`;

              readingTableHtml +=
              `<td>
                <div class="badge bg-label-secondary tooltip1">
                  <i class="fa-solid me-2 fa-circle-exclamation"></i> ` + tableConfig.data[j][k] +
                `<span class="tooltiptext1">The current reading is above or close to the minimum value</span>
                </div>
              </td>`;
            } else {
              readingTableHtml +=
              `<td>-</td>`;
            }
          }
        }
        readingTableHtml += '</tr>';
      }
      readingTableHtml += '</tbody>';
    }

    return readingTableHtml;
  }
}
